document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("#search-btn");
  const close = document.querySelector(".search-close");

  const wpAdminBar = document.querySelector("#wpadminbar");
  const overlay = document.querySelector(".overlay-search");

  if (document.body.contains(wpAdminBar)) {
    overlay.style.top = "32px";
  }

  btn.addEventListener("click", () => {
    overlay.classList.toggle("active");
    document.body.style.overflow = "hidden";
  });

  // Helper function to remove search-related classes
  const removeSearchClasses = () => {
    if (overlay) {
      overlay.classList.remove("search-results-loaded");
    }
    jQuery(".search-completed").removeClass("search-completed");
    jQuery(".results-visible").removeClass("results-visible");
  };

  close.addEventListener("click", () => {
    overlay.classList.remove("active");
    document.body.style.overflow = "auto";
    removeSearchClasses(); // Remove search-related classes
  });

  // close on escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      overlay.classList.remove("active");
      document.body.style.overflow = "auto";
      removeSearchClasses(); // Remove search-related classes
    }
  });

  // Listen to Relevanssi live search success event
  jQuery(document).on(
    "relevanssi_live_search_success",
    function (event, $input, $results, $form, action, values) {
      // Add class to an element when search results are loaded
      // Example: Add a class to the search overlay or results container
      if (overlay) {
        overlay.classList.add("search-results-loaded");
      }

      // You can also target specific elements based on the event data
      // For example, add class to the input field that triggered the search
      if ($input && $input.length) {
        $input.addClass("search-completed");
      }

      // Or add class to the results container
      if ($results && $results.length) {
        $results.addClass("results-visible");
      }

      console.log("Relevanssi live search completed", {
        input: $input,
        results: $results,
        form: $form,
        action: action,
        values: values,
      });
    }
  );

  // Listen to Relevanssi live search destroy/hide event
  jQuery(document).on("relevanssi_live_destroy_results", function (event) {
    // Remove classes when search results are hidden/destroyed
    if (overlay) {
      overlay.classList.remove("search-results-loaded");
    }

    // Remove classes from any previously affected elements
    jQuery(".search-completed").removeClass("search-completed");
    jQuery(".results-visible").removeClass("results-visible");
  });

  // Handle Load More button clicks for search results
  jQuery(document).on("click", ".relevanssi-load-more-btn", function (e) {
    e.preventDefault();

    const $button = jQuery(this);
    const $container = $button.closest(".relevanssi-load-more-container");
    const $loadMoreText = $container.find(".relevanssi-load-more-text");
    const $loadText = $container.find(".relevanssi-load-text");

    // Get pagination data
    const currentPage = parseInt($container.data("current-page")) || 1;
    const maxPages = parseInt($container.data("max-pages")) || 1;
    const searchQuery = $container.data("search-query") || "";
    const language = $container.data("language") || "";

    // Calculate next page
    const nextPage = currentPage + 1;

    // Don't proceed if we're already on the last page
    if (nextPage > maxPages) {
      return;
    }

    // Show spinner, hide button
    $loadText.hide();
    $loadMoreText.removeClass("hidden");

    // Make AJAX request
    jQuery.ajax({
      url: gekas.ajax_url,
      type: "POST",
      data: {
        action: "load_more_search_results",
        nonce: gekas.load_more_nonce,
        search_query: searchQuery,
        page: nextPage,
        language: language,
      },
      success: function (response) {
        if (response.success && response.data.html) {
          // Append new results before the load more container
          $container.before(response.data.html);

          // Update pagination data
          $container.data("current-page", response.data.current_page);

          // Check if there are more pages
          if (response.data.has_more) {
            // Show button again for next page
            $loadText.show();
          } else {
            // No more results, hide the entire container
            $container.hide();
          }
        } else {
          // Error or no more results
          $container.hide();
          console.log("No more results or error:", response);
        }
      },
      error: function (xhr, status, error) {
        console.error("Load More AJAX error:", error);
        $loadText.show();
        alert("Failed to load more results. Please try again.");
      },
      complete: function () {
        // Hide spinner
        $loadMoreText.addClass("hidden");
      },
    });
  });
});
